import { Pipe, PipeTransform } from '@angular/core';
import { GLOBAL_CONSTANT } from '../constants/global.constant';

@Pipe({
  name: 'sanitizeInput',
})
export class SanitizeInputPipe implements PipeTransform {
  transform(value: string): string {
    return value?.replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, '') ?? GLOBAL_CONSTANT.EMPTY_STRING;
  }
}
